import React from 'react'

const UploadMarkerfileTooltip = ({ intro }) => (
  <div className='upload-markerfile-tooltip'>
    <h3>{intro}: 'Name', 'Latitude', 'Longitude', and 'Description'.</h3>
    <p>Sample:</p>
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Latitude</th>
          <th>Longitude</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Alabama</td>
          <td>32.806671</td>
          <td>-86.79113</td>
          <td>22<sup>th</sup> state</td>
        </tr>
        <tr>
          <td>Alaska</td>
          <td>61.370716</td>
          <td>-152.404419</td>
          <td>49<sup>th</sup> state</td>
        </tr>
        <tr>
          <td>Arizona</td>
          <td>33.729759</td>
          <td>-111.431221</td>
          <td>48<sup>th</sup> state</td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default UploadMarkerfileTooltip
